module.exports = __webpack_public_path__ + "static/blog10-b2c4604e7ea3b5f5d0ae8cc0c0f06527.png";